<mat-toolbar class="dhl-gradient-horizontal">
  <mat-toolbar-row *ngIf="isEnableMenu && isEnableOption" class="navbar-menu-dhl">
    <label for="menu" class="div-square-menu-responsive">
      <div class="line line-1"></div>
      <div class="line line-2"></div>
    </label>
    <div class="container text-center">
      <div class="nombre-header-responsive opt-nav-responsive">Nombre completo del usuario</div>
      <div class="row row-cols-auto justify-content-md-left menu-navbar" id="menu-navbar">
        <div (click)="hiddenMenu(false)" *ngIf="isEnableOption" class="col-md-auto option opt-nav-responsive opt-home scroll-manu" routerLink="/homepage">Inicio</div>
        <label for="option1" *ngIf="isEnableOption" class="col-md-auto option-toggle opt-nav-responsive">
          <input type="checkbox" [(ngModel)]="opcionesmenu[0].seleccionada" (change)="deseleccionarMenusChecks(0)" id="option1" class="opt-check" />
          <span class="span-option">Administración</span>
          <mat-icon class="icon-arrow-down">keyboard_arrow_down</mat-icon>
          <div class="div-options-toggle">
            <div class="triangulo"></div>
            <ul>
              <li (click)="hiddenMenu(true)" routerLink="/management/users">Usuarios</li>
              <li (click)="hiddenMenu(true)" routerLink="/management/roles">Roles</li>
            </ul>
          </div>
        </label>

        <label *ngIf="isEnableOption" for="option2" class="col-md-auto option-toggle opt-nav-responsive">
          <input type="checkbox" [(ngModel)]="opcionesmenu[1].seleccionada" (change)="deseleccionarMenusChecks(1)" id="option2" class="opt-check" />
          <span class="span-option">Cotización / Orden de compra</span>
          <mat-icon class="icon-arrow-down">keyboard_arrow_down</mat-icon>
        </label>

        <div *ngIf="isEnableOption" (click)="hiddenMenu(false)" class="col-md-auto option opt-nav-responsive">Facturación</div>

        <div *ngIf="isEnableOption" (click)="hiddenMenu(false)" class="col-md-auto option opt-nav-responsive" routerLink="/management/reports">Reportes</div>

        <label *ngIf="isEnableOption" for="option3" class="col-md-auto option-toggle opt-nav-responsive">
          <input type="checkbox" [(ngModel)]="opcionesmenu[2].seleccionada" (change)="deseleccionarMenusChecks(2)" id="option3" class="opt-check" />
          <span class="span-option">Tesoreria</span>
          <mat-icon class="icon-arrow-down">keyboard_arrow_down</mat-icon>
        </label>

        <div *ngIf="isEnableOption" (click)="hiddenMenu(false)" class="col-md-auto option opt-nav-responsive">Retail</div>

        <label *ngIf="isEnableOption" for="option4" class="col-md-auto option-toggle opt-nav-responsive">
          <input type="checkbox" [(ngModel)]="opcionesmenu[3].seleccionada" (change)="deseleccionarMenusChecks(3)" id="option4" class="opt-check" />
          <span class="span-option">Cliente</span>
          <mat-icon class="icon-arrow-down">keyboard_arrow_down</mat-icon>
          <div class="div-options-toggle">
            <div class="triangulo"></div>
            <ul>
              <li (click)="hiddenMenu(true)" routerLink="/clients/print-guides">Impresión</li>
              <li (click)="hiddenMenu(true)" routerLink="/clients/guides-managment">Administrar guías</li>
            </ul>
          </div>
        </label>

        <div *ngIf="isEnableOption" (click)="showModalLogout()" class="col-md-auto option opt-nav-responsive opt-iniciar-sesion">
          <mat-icon class="icon-head">exit_to_app</mat-icon>
          <span class="span-option">Cerrar sesión</span>
        </div>
        <div class="col-md-auto option opt-nav-responsive" routerLink="/authentication/login"></div>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav-container autosize>
  <mat-sidenav #navigationSidenav mode="over" role="navigation" class="d-block d-sm-none">
    <mat-nav-list>
      <ng-container *ngFor="let option of menuOptions">
        <ng-container *ngIf="option.submenu && option.submenu.length > 0">
          <a mat-list-item [matMenuTriggerFor]="menu.subMenu">
            <mat-icon class="dhl-nav-list-icon">{{ option.icon }}</mat-icon>
            {{ option.menuName }}
            <mat-icon>arrow_right</mat-icon>
          </a>
          <dhl-menu-item #menu [options]="option.submenu" (closeSidenav)="navigationSidenav.toggle()"></dhl-menu-item>
        </ng-container>
        <ng-container *ngIf="!option.submenu || option.submenu.length === 0">
          <a mat-list-item (click)="navigationSidenav.close()" [routerLink]="[option.url]" routerLinkActive="dhl-menu-active">
            <mat-icon class="dhl-nav-list-icon">{{ option.icon }}</mat-icon>
            {{ option.menuName }}
          </a>
        </ng-container>
      </ng-container>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content role="main">
    <div class="dhl-main-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
